import { NgModule } from '@angular/core';
import { AdItemV2Component } from './ad-item-v2.component';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { ButtonModule } from '../button/button.module';
import { PhotoLayoutModule } from '../photo-layout/photo-layout.module';

@NgModule({
	declarations: [AdItemV2Component],
	imports: [SharedModule, NgbCarouselModule, ButtonModule, PhotoLayoutModule],
	exports: [AdItemV2Component],
})
export class AdItemV2Module {}
